module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/buttons/pagination-button/pagination-button.component.scss
// module id = ./src/app/features/buttons/pagination-button/pagination-button.component.scss
// module chunks = main